import { Component, Injectable, Input } from '@angular/core';
import { SavedState, UNSAVED_DATA_HANDLER_TOKEN, UnsavedDataHandler } from '@galaxy/email-ui/domain-authorization';
import { FormPayload } from '@galaxy/email-ui/sender-chooser';
import { SenderType } from '@vendasta/email';
import { ComponentCanDeactivate } from '../../../../core/pending-changes.guard';

@Injectable()
class UnsavedChanges implements UnsavedDataHandler {
  private hasUnsavedChanges = false;

  canDeactivate(): boolean {
    return !this.hasUnsavedChanges;
  }

  notifyStateChanged(newState: SavedState): void {
    switch (newState) {
      case SavedState.SAFE_TO_NAVIGATE_AWAY:
        this.hasUnsavedChanges = false;
        return;
      case SavedState.HAS_UNSAVED_CHANGES:
        this.hasUnsavedChanges = true;
        return;
      default:
        throw new Error(`Unexpected SavedState: ${newState}`);
    }
  }
}

import { CommonModule } from '@angular/common';
import { DomainAuthorizationComponent } from '@galaxy/email-ui/domain-authorization';
import { GalaxyEmptyStateModule } from '@vendasta/galaxy/empty-state';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-domain-records',
  templateUrl: './domain-records.component.html',
  styleUrls: ['./domain-records.component.scss'],
  providers: [UnsavedChanges, { provide: UNSAVED_DATA_HANDLER_TOKEN, useExisting: UnsavedChanges }],
  imports: [CommonModule, DomainAuthorizationComponent, GalaxyEmptyStateModule, MatIconModule],
})
export class DomainRecordsComponent extends ComponentCanDeactivate {
  _selectorSelection: FormPayload;

  @Input()
  set selection(v: { senderType: SenderType; senderId: string }) {
    this._selectorSelection = v;
  }

  constructor(private readonly unsavedChanges: UnsavedChanges) {
    super();
  }

  canDeactivate(): boolean {
    return this.unsavedChanges.canDeactivate();
  }
}
